<template>
  <div class="column_center_around order_method_container" @click="closeTimePicker">
    <text class="title">{{ deliverySelectionTitle }}</text>
    <div class="w-full h-[56px] mt-5 mb-2.5 border border-[#AAAAAA] rounded-md">
      <el-date-picker size="large" v-model="selectedDate" type="date" placeholder="送達日期 *" :disabled-date="disabledDate"
        :editable="false" :clearable="false"></el-date-picker>
    </div>
    <div class="w-full h-[56px] my-2.5 border border-[#AAAAAA] rounded-md relative"
      @click.stop="showTimePicker ? closeTimePicker() : displayTimePicker()">
      <div class="w-full h-full flex items-center justify-between px-3" v-if="!selectedTime">
        <div class="w-full h-full text-[22px] font-normal flex items-center" style="color: rgba(0, 0, 0, 0.3);">
          {{ timePlaceholder }}
        </div>
        <text class="button-icon size-7 text-[28px] self-center cursor-pointer"
          style="color: #FBCB02;">expand_more</text>
      </div>
      <div class="w-full h-full flex items-center justify-between text-[22px] font-normal px-3"
        style="color: #000;" v-else>
        {{ selectedTime }}
        <text class="button-icon size-7 text-[28px] self-center cursor-pointer"
          style="color: #FBCB02;">expand_more</text>
      </div>
      <transition name="time-picker-transition">
        <div class="w-[110%] left-[-5%] absolute top-[64px] bg-white grid py-4 px-2 rounded-md time-picker z-10"
          :class="timePickerClass" v-if="showTimePicker">
          <div class="time-option flex items-center justify-center mx-1.5 px-4 h-11 border border-[#AAAAAA] rounded-md mb-2"
            v-for="(item, index) in timeOptions" :key="index" @click.stop="pickTime(item)">
            {{ item }}
          </div>
        </div>
      </transition>
    </div>
   <div class="invoice-divider"></div> 
    <!-- 收件人資訊標題與常用地址按鈕 -->
    <div class="row_center_between w-full mt-2 mb-2">
      <text class="title">收件人資訊</text>
      <button class="commonly_use" @click="openPickAddress">常用地址</button>
    </div>
    
    <div class="row_center_between w-full h-[54px] my-2.5">
      <div class="area_select h-[56px] border border-[#AAAAAA] rounded-md" :class="{ 'has-value': isCitySelected }">
        <el-select id="county-select" v-model="selectedCity" size="large" placeholder="縣市">
          <el-option value="縣市" disabled selected hidden>縣市</el-option>
          <el-option v-for="(city, index) in cities" :value="city.id" :key="index" :label="city.name">
          </el-option>
        </el-select>
      </div>
      
      
      <div class="area_select h-[56px] border border-[#AAAAAA] rounded-md" :class="{ 'has-value': isCityAreaSelected }">
        <el-select id="area-select" v-model="selectedCityArea" size="large" placeholder="區域">
          <el-option value="區域" disabled selected hidden>區域</el-option>
          <el-option v-for="(area, index) in matchedCityAreas" :value="area.id" :key="index" :label="area.name">
          </el-option>
        </el-select>
      </div>
    </div>
    <input class="input" placeholder="地址 *" style="text-align: left" v-model="inputAddress" />
    <input 
      class="input" 
      placeholder="聯絡人 *" 
      style="text-align: left" 
      v-model="recipientName" 
      maxlength="20" 
    />
    <input inputmode="tel" v-model="phone" class="input" placeholder="電話 *" style="text-align: left" maxlength="15" />
    
    <!-- 發票資訊分隔線 -->
    <div v-if="shouldShowInvoiceSelector" class="invoice-divider"></div>
    
    <!-- 整合 InvoiceSelector 組件 -->
    <InvoiceSelector 
      ref="invoiceSelectorRef"
      v-if="shouldShowInvoiceSelector"
      @invoice-updated="handleInvoiceUpdated"
      @validation-error="handleValidationError"
    />
    
    <div class="column_start_start hint">
      <!-- 情況1: freeShipping > 0 且 shippingFee > 0，顯示完整訊息 -->
      <template v-if="freeShipping > 0 && shippingFee > 0">
        <p>消費滿{{ freeShipping }}元免費外送。</p>
        <p>未滿{{ freeShipping }}元，需加收運費{{ shippingFee }}元。</p>
      </template>
      
      <!-- 情況2: freeShipping = 0 但 shippingFee > 0，只顯示運費訊息 -->
      <p v-else-if="freeShipping === 0 && shippingFee > 0">需加收運費{{ shippingFee }}元。</p>
      
      <!-- 情況3: shippingFee = 0，不顯示任何訊息 -->
    </div>

    <button class="button" :disabled="isSubmitting" @click="toOrderPage">
      {{ isSubmitting ? '處理中…' : buttonText }}
    </button>
    <PickAddressPopup v-if="showPickAddressPopup" @close="closePickAddress" />
  </div>
</template>
<script>
import commonUtilities from "@/utils/common.utils";
import Swal from "sweetalert2";
import areaData from "@/area_data"
import pickAddressPopup from "./pickAddressPopup.vue";
import InvoiceSelector from "./InvoiceSelector.vue";
import { dayjs } from 'element-plus';
import {
  mapState,
  mapGetters
} from 'vuex';

export default {
  components: {
    PickAddressPopup: pickAddressPopup,
    InvoiceSelector,
  },
  props: {
    isRetailDelivery: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedDate: "",
      selectedTime: "",
      timeOptions: [],
      deliveryPeriodOptions: ['上午', '下午'],
      selectedCity: "縣市 *",
      selectedCityArea: "區域 *",
      inputAddress: "",
      matchedCityAreas: [],
      isLoading: true,
      phone: "",
      recipientName: "",
      showPickAddressPopup: false,
      showTimePicker: false,
      isCitySelected: false,
      isCityAreaSelected: false,
      disabledDate: (d) => {
        // 禁用今天之前的日期
        if (dayjs(d).isBefore(dayjs(), 'day')) {
          return true
        }

        // 禁用公休日（沒有營業時間的日期）
        const dayOfWeek = dayjs(d).day()
        const getterMap = {
          0: 'sundayBusinessHours',
          1: 'mondayBusinessHours',
          2: 'tuesdayBusinessHours',
          3: 'wednesdayBusinessHours',
          4: 'thursdayBusinessHours',
          5: 'fridayBusinessHours',
          6: 'saturdayBusinessHours'
        }

        const getterName = getterMap[dayOfWeek]
        const businessHours = this.$store.getters[`basic/${getterName}`] || []

        // 如果該日期沒有營業時間，則禁用
        return businessHours.length === 0
      },
      // 送出中旗標：防止驗證期間重複點擊
      isSubmitting: false
    };
  },
  computed: {
    buttonText() {
      return this.isRetailDelivery ? '宅配下單' : '外送點餐'
    },
    deliverySelectionTitle() {
      return this.isRetailDelivery ? '選擇送達時段' : '選擇送達時間'
    },
    timePlaceholder() {
      return this.isRetailDelivery ? '送達時段 *' : '送達時間 *'
    },
    timePickerClass() {
      return this.isRetailDelivery ? 'period-picker' : 'time-grid-picker'
    },
    ...mapState('userData', {
      getToken: 'token',
      memberInfo: 'memberInfo',
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin'
    }),
    ...mapState('basic', {
      getSelectedAddressData: 'selectedAddressData',
      currentStore: 'currentStore',
      cities: 'cities',
      cityAreas: 'cityAreas',
    }),
    ...mapGetters('basic', {
      todayBusinessHours: 'todayBusinessHours',
      tomorrowBusinessHours: 'tomorrowBusinessHours',
      deliveryDelayHour: 'deliveryDelayHour',
      deliveryDelayMinute: 'deliveryDelayMinute',
      retailDeliveryDelayHour: 'retailDeliveryDelayHour',
      retailDeliveryDelayMinute: 'retailDeliveryDelayMinute',
      freeShipping: 'freeShipping',
      shippingFee: 'shippingFee'
    }),
    currentDeliveryDelayHour() {
      return this.isRetailDelivery ? this.retailDeliveryDelayHour : this.deliveryDelayHour
    },
    currentDeliveryDelayMinute() {
      return this.isRetailDelivery ? this.retailDeliveryDelayMinute : this.deliveryDelayMinute
    },
    getBusinessHoursByDayOfWeek() {
      return (dayOfWeek) => {
        const getterMap = {
          0: 'sundayBusinessHours',
          1: 'mondayBusinessHours',
          2: 'tuesdayBusinessHours',
          3: 'wednesdayBusinessHours',
          4: 'thursdayBusinessHours',
          5: 'fridayBusinessHours',
          6: 'saturdayBusinessHours'
        }

        const getterName = getterMap[dayOfWeek]
        return this.$store.getters[`basic/${getterName}`] || []
      }
    },
    getDefaultAddressData() {
      const addresses = this.memberInfo.addresses;
      if (!addresses?.length) {
        return {}
      }
      // 優先找出 is_default === 1 的預設地址
      const defaultAddress = this.memberInfo.addresses.find((address) => {
        return address.is_default === 1
      })
      // 如果有預設地址就返回，否則返回第一個地址
      return defaultAddress || addresses[0]
    },
    // 判斷是否顯示發票選項
    shouldShowInvoiceSelector() {
      return this.$store.getters['basic/enableInvoiceSelector']
    }
  },
  watch: {
    isLoading(state) {
      if (!state) {
        Swal.clickCancel();
      }
    },
    selectedCity(newVal) {
      this.matchedCityAreas = []
      // 在 cityAreas 中找出與 this.selectedCity 相同的 city_id
      for (const cityArea of this.cityAreas) {
        if (cityArea.city_id == this.selectedCity) {
          this.matchedCityAreas.push(cityArea)
        }
      }

      const isCityAreaMatched = this.matchedCityAreas.some((cityArea) => {
        return cityArea.id == this.selectedCityArea
      })
      if (!isCityAreaMatched) {
        this.selectedCityArea = ""
      }
      // this.modifiedAddressData.city_id = this.selectedCity
      console.log('selectedCity', this.selectedCity)
      
      // 更新選擇狀態
      this.isCitySelected = newVal !== "" && newVal !== "縣市 *"
    },
    selectedCityArea(newVal) {
      // this.modifiedAddressData.cityarea_id = this.selectedCityArea
      console.log('selectedCityArea', this.selectedCityArea)
      const postcode = areaData[this.selectedCityArea]
      // this.modifiedAddressData.postcode = postcode
      console.log('郵遞區號', postcode)
      
      // 更新選擇狀態
      this.isCityAreaSelected = newVal !== "" && newVal !== "區域 *"
    },
    getSelectedAddressData() {
      this.selectedCity = this.getSelectedAddressData.city_id
      this.selectedCityArea = this.getSelectedAddressData.cityarea_id
      this.inputAddress = this.getSelectedAddressData.address
      this.phone = this.getSelectedAddressData.phone
      this.recipientName = this.getSelectedAddressData.name || ""
      
      // 新增：儲存 addressId 到 payment（用於後續編輯時識別）
      if (this.getSelectedAddressData.id) {
        const payment = this.$store.state.cart.payment || {}
        this.$store.commit("cart/setPayment", {
          ...payment,
          addressId: this.getSelectedAddressData.id
        })
      }
    },
    selectedDate() {
      this.closeTimePicker()
      this.selectedTime = ""
      this.timeOptions = []
      this.setupTimeOptions()
    }
  },
  async mounted() {
    this.initialize()
    let suffixIcons = document.getElementsByClassName('el-select__suffix')
    if (suffixIcons.length > 0) {
      for (const el of suffixIcons) {
        el.innerHTML = '<text id="expand_more" class="button-icon" style="color: #FBCB02; font-size: 28px; width: 28px; height: 28px;">expand_more</text>'
      }
    }
  },
  methods: {
    setupTimeOptions() {
      if (!this.selectedDate) {
        return
      }

      if (this.isRetailDelivery) {
        this.timeOptions = [...this.deliveryPeriodOptions]
        return
      }
      
      const today = new Date()
      const tomorrow = new Date(today)
      tomorrow.setDate(tomorrow.getDate() + 1)
      const selectedDateStr = commonUtilities.convertDate(this.selectedDate)
      const todayStr = commonUtilities.convertDate(today)
      const tomorrowStr = commonUtilities.convertDate(tomorrow)
      
      this.timeOptions = []
      
      if (selectedDateStr === todayStr) {
        // 今天
        if (this.todayBusinessHours && this.todayBusinessHours.length > 0) {
          for (const item of this.todayBusinessHours) {
            this.timeOptionHelper({...item}, true)
          }
        }
      } else if (selectedDateStr === tomorrowStr) {
        // 明天
        if (this.tomorrowBusinessHours && this.tomorrowBusinessHours.length > 0) {
          for (const item of this.tomorrowBusinessHours) {
            this.timeOptionHelper({...item}, false)
          }
        }
      } else {
        // 未來日期
        const selectedDayOfWeek = dayjs(this.selectedDate).day()
        const businessHours = this.getBusinessHoursByDayOfWeek(selectedDayOfWeek)

        if (businessHours && businessHours.length > 0) {
          for (const item of businessHours) {
            this.timeOptionHelper({...item}, false)
          }
        }
      }
      
      this.timeOptions = this.timeOptions.filter((item, index, self) => self.indexOf(item) === index)
    },
    
    timeOptionHelper(item, isToday = false) {
      const today = new Date()
      
      // 只有在選擇今天時,才需要考慮當前時間
      if (isToday) {
        const currentHourLargerThanStartHour = Number(item.startTime.split(':')[0]) < today.getHours()
        const currentMinuteLargerThanStartMinute = Number(item.startTime.split(':')[1]) < today.getMinutes()
        const currentHourEqualToStartHour = Number(item.startTime.split(':')[0]) === today.getHours()
        if (currentHourLargerThanStartHour || (currentHourEqualToStartHour && currentMinuteLargerThanStartMinute)) {
          item.startTime = `${today.getHours()}:${today.getMinutes()}`
        }
      }
      
      // 加入店家設定等候時間
      let startHour = parseInt(item.startTime.split(':')[0]) + this.currentDeliveryDelayHour;
      let startMinute = parseInt(item.startTime.split(':')[1]) + this.currentDeliveryDelayMinute;
      
      // 處理分鐘進位
      if (startMinute >= 60) {
        startHour += 1;
        startMinute -= 60;
      }

      const endHour = parseInt(item.endTime.split(':')[0])
      const endMinute = parseInt(item.endTime.split(':')[1])

      for (let hour = startHour; hour <= endHour; hour++) {
        for (let minute = 0; minute < 60; minute += 15) {
          if (hour === startHour && minute < startMinute) {
            continue
          }
          if (hour === endHour && minute > endMinute) {
            break
          }
          let time = `${hour < 10 ? '0' + hour : hour}:${minute < 10 ? '0' + minute : minute}`
          this.timeOptions.push(time)
        }
      }
    },
    
    pickTime(time) {
      this.selectedTime = time
      this.closeTimePicker()
    },
    
    displayTimePicker() {
      if (!this.selectedDate) {
        commonUtilities.createToast('info', '請先選擇日期')
        return
      }
      event.stopPropagation();
      event.preventDefault();
      this.showTimePicker = true
    },
    
    closeTimePicker() {
      if (event) {
        event.stopPropagation();
        event.preventDefault();
      }
      this.showTimePicker = false
    },
    
    validatePhoneNumber(phone) {
      // 移除空白和連字號
      const cleanPhone = phone.replace(/[\s-]/g, '')
      
      // 手機：09 開頭 10 碼（優先檢查，避免被市話規則誤判）
      const mobilePattern = /^09\d{8}$/
      if (mobilePattern.test(cleanPhone)) {
        return true
      }
      
      // 市話：區碼 + 號碼（排除 09 開頭）
      const landlinePatterns = [
        /^02\d{7,8}$/,        // 台北市
        /^0[3-8]\d{7}$/,      // 其他縣市 7 碼
        /^0[3-8]\d{6}$/,      // 其他縣市 6 碼
        /^0[3-8]{2}\d{5,6}$/  // 三碼區碼
      ]
      
      // 檢查市話格式
      for (const pattern of landlinePatterns) {
        if (pattern.test(cleanPhone)) {
          return true
        }
      }
      
      return false
    },
    
    async toOrderPage() {
      // 送出中不重複觸發（避免驗證期間連點）
      if (this.isSubmitting) return
      this.isSubmitting = true
      try {
        // 觸發所有輸入框失焦，確保發票資料已更新
        if (document.activeElement instanceof HTMLElement) {
          document.activeElement.blur()
        }

        if (!this.validateForm()) {
          return
        }

        // 驗證發票資訊（放在本地必填檢查之後，避免白等 API）
        if (this.shouldShowInvoiceSelector && this.$refs.invoiceSelectorRef) {
          const isValid = await this.$refs.invoiceSelectorRef.validate()
          if (!isValid) {
            const errorMessage = this.$refs.invoiceSelectorRef.errorMessage
            if (errorMessage) {
              commonUtilities.createToast('error', errorMessage)
            }
            return
          }
        }

        let payment = this.$store.state.cart.payment || {}

        // 保留現有的 addressId（如果有的話）
        const existingAddressId = payment.addressId || null

        // TODO: 需轉成 UTC 時間
        let pickupDate = commonUtilities.convertDate(this.selectedDate)
        payment.pickupDate = pickupDate
        if (this.isRetailDelivery) {
          payment.pickupTime = null
          payment.deliveryPeriod = this.selectedTime
        } else {
          payment.pickupTime = this.selectedTime
          payment.deliveryPeriod = null
        }
        payment.phone = this.phone
        payment.recipientName = this.recipientName
        const city = this.getSelectedCity()
        const cityArea = this.getSelectedCityArea()
        console.log(city, cityArea)
        payment.address = city.name + cityArea.name + this.inputAddress

        // 保留 addressId（不需要手動合併發票資料，InvoiceSelector 已即時更新）
        if (existingAddressId) {
          payment.addressId = existingAddressId
        }

        this.$store.commit("cart/setPayment", payment)
        const data = {
          method: 'delivery'
        }
        this.$store.commit('cart/setTableData', {
          areaId: null,
          tableIndex: -1,
        })
        this.$emit('toOrderPage', data)
      } finally {
        this.isSubmitting = false
      }
    },
    validateForm() {
      if (this.selectedDate === "") {
        commonUtilities.createToast("error", "請選擇日期");
        return false;
      }
      if (this.selectedTime === "") {
        commonUtilities.createToast("error", this.isRetailDelivery ? "請選擇送達時段" : "請選擇送達時間");
        return false;
      }
      if (!this.getSelectedCity()) {
        commonUtilities.createToast("error", "請選擇縣市");
        return false;
      }
      if (!this.getSelectedCityArea()) {
        commonUtilities.createToast("error", "請選擇區域");
        return false;
      }
      if (this.inputAddress === "" || this.inputAddress.trim() === "") {
        commonUtilities.createToast("error", "請輸入地址");
        return false;
      }
      if (this.recipientName === "" || this.recipientName.trim() === "") {
        commonUtilities.createToast("error", "請輸入聯絡人姓名");
        return false;
      }
      if (this.phone === "") {
        commonUtilities.createToast("error", "請輸入聯絡電話");
        return false;
      }
      if (!this.validatePhoneNumber(this.phone)) {
        commonUtilities.createToast("error", "請輸入正確的電話號碼格式（手機：09開頭10碼，或市話含區碼）");
        return false;
      }
      
      return true;
    },
    getSelectedCity() {
      return this.cities.find((city) => {
        return city.id == this.selectedCity
      })
    },
    getSelectedCityArea() {
      return this.cityAreas.find((cityArea) => {
        return cityArea.id == this.selectedCityArea && cityArea.city_id == this.selectedCity
      })
    },
    closePickAddress() {
      this.showPickAddressPopup = false
    },
    openPickAddress() {
      this.showPickAddressPopup = true
    },
    async initialize() {
      try {
        if (!this.isLogin) {
          commonUtilities.createToast("warning", "登入狀態已過期，請重新登入");
          await commonUtilities.delay(2000)
          this.$router.push({
            path: `/${this.getCurrentStore}`
          })
          return
        }
        if (!this.cities.length) await this.$store.dispatch('basic/fetchCities')
        if (!this.cityAreas.length) await this.$store.dispatch('basic/fetchCityAreas')
        this.$store.dispatch('userData/fetchMemberInfo')
        console.log('member info', this.memberInfo)
        if (this.memberInfo.addresses.length) {
          // 每次載入組件時，強制重置為預設地址
          const defaultAddress = this.getDefaultAddressData;
          
          console.log('重置為預設地址', defaultAddress)
          this.selectedCity = defaultAddress.city_id
          this.selectedCityArea = defaultAddress.cityarea_id
          this.inputAddress = defaultAddress.address
          this.phone = defaultAddress.phone
          this.recipientName = defaultAddress.name || ""
          
          // 重置 store 中的地址選擇狀態為預設地址
          this.$store.commit("basic/setSelectedAddressData", defaultAddress)
          
          // 儲存預設地址的 addressId 到 payment
          if (defaultAddress.id) {
            const payment = this.$store.state.cart.payment || {}
            this.$store.commit("cart/setPayment", {
              ...payment,
              addressId: defaultAddress.id
            })
          }
        } else {
          // 會員沒有設定地址，清除選擇狀態
          this.$store.commit("basic/setSelectedAddressData", null)
          
          // 使用會員基本資料
          console.log('會員沒有設定地址，使用會員基本資料')
          this.recipientName = this.memberInfo.name || ""
          this.phone = this.memberInfo.mobile_phone || ""
        }

        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        await commonUtilities.delay(500)
        commonUtilities.createToast('error', error?.message || String(error))
        console.log(error)
      }
    },
    
    // 處理發票資料更新事件
    handleInvoiceUpdated(invoiceData) {
      console.log('delivery.vue 收到發票資料更新:', invoiceData)
      // InvoiceSelector 已經更新了 Vuex store，這裡只需要記錄日誌
    },
    
    // 處理發票驗證錯誤事件
    handleValidationError(errorMessage) {
      console.error('delivery.vue 收到發票驗證錯誤:', errorMessage)
      // 可以選擇顯示錯誤訊息給使用者
      // commonUtilities.createToast('error', errorMessage)
    }
  },
};
</script>
<style lang="scss" scoped>
.area_select {
  width: 47%;
}

.hint {
  width: 100%;
  line-height: 20px;
  font-size: 14px;
  font-family: PingFang SC;
  color: #fd5001;
  margin-bottom: 15px;
}

.commonly_use {
  width: auto;
  height: 34px;
  background-color: #DDDDDD;
  border-radius: 30px;
  font-size: 16px;
  font-weight: 500;
  color: #000;
  border: none;
  padding: 0 20px;
}

// 調整 el-date-picker 圖示位置（移動到右側而非隱藏）
:deep(.el-date-editor) {
  position: relative;
  
  // 將左側圖示移動到右側
  .el-input__prefix {
    position: absolute;
    right: 4px;
    left: auto;
    z-index: 1;
    
    .el-input__prefix-inner {
      .el-icon {
        color: #FBCB02;
        font-size: 28px;
        width: 28px;
        height: 28px;
      }
    }
  }
  
  // 調整輸入框樣式
  .el-input__inner {
    padding-left: 2px;
    padding-right: 40px;
  }
}

// 時間選擇器動畫
.time-picker-transition-enter-active,
.time-picker-transition-leave-active {
  transition: 0.2s ease-in-out;
}

.time-picker-transition-enter-from,
.time-picker-transition-leave-to {
  max-height: 0;
  opacity: 0;
  transform: scaleY(0);
}

.time-picker-transition-enter-to,
.time-picker-transition-leave-from {
  opacity: 1;
  transform: scaleY(1);
}

.time-picker {
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
  -webkit-box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
  -moz-box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.12);
}

.time-grid-picker {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.period-picker {
  grid-template-columns: repeat(2, minmax(0, 132px));
  justify-content: center;
  gap: 12px;
  padding: 24px 20px;

  .time-option {
    width: 132px;
    height: 52px;
    margin: 0;
    font-size: 22px;
  }
}

// 輸入框文字顏色
.input {
  color: #000;
  
  &::placeholder {
    color: rgba(0, 0, 0, 0.3);
  }
}

// Element Plus 下拉選單樣式（簡化版）
.area_select {
  // 預設 placeholder 為灰色
  :deep(.el-select__placeholder) {
    color: rgba(0, 0, 0, 0.3) !important;
  }
  
  // 當有值時，文字為黑色
  &.has-value {
    :deep(.el-select__selected-item) {
      color: #000 !important;
    }
    
    :deep(input) {
      color: #000 !important;
    }
    
    :deep(.el-input__inner) {
      color: #000 !important;
    }
  }
}

// Element Plus 日期選擇器文字顏色
:deep(.el-date-editor) {
  .el-input__inner {
    color: #000;
  }
  
  .el-input__inner::placeholder {
    color: rgba(0, 0, 0, 0.3);
  }
}

.invoice-divider {
  width: 100%;
  height: 1px;
  background-color: #DDDDDD;
  margin: 16px 0;
}
</style>
